import { travel } from 'api';

import { Response } from 'models/response';

export type AirSearchTypeResponse = {
  isDomestic: boolean;
  isInternational: boolean;
};

export const getAirSearchType = (origin: string, destination: string): Promise<AirSearchTypeResponse> =>
  travel
    .post<Response<AirSearchTypeResponse>>('Air/AirSearchType', {
      origin,
      destination,
    })
    .then((response) => response.data.data);
